// extracted by mini-css-extract-plugin
export default {"switchLabel":"CampaignWebhookModal_switchLabel__SjpaM","webhookFieldRow":"CampaignWebhookModal_webhookFieldRow__BwuEl"};